import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  apiUrl = environment.apiUrl;
  _login = this.apiUrl + '/brokerLogin';
  _verify = this.apiUrl + '/verifyBroker';
  _checkLogin = this.apiUrl + '/checkBrokerLogin';
  _logout = this.apiUrl + '/brokerLogout';
  token : any;
  header : any;
  constructor(
    private http: HttpClient
  ) { }

  login( data : any ){
    return this.http.post(this._login , data );
  }
  verifyOTP(data : any){
    return this.http.post(this._verify, data);
  }
  checkLogin(){
    this.token = localStorage.getItem('token');
    this.header = new HttpHeaders({
      Authorization: 'Bearer ' + this.token,
      Accept: '*/*',
    });
    return this.http.post(this._checkLogin, {}, { headers: this.header });
  }
  logout(){
    this.token = localStorage.getItem('token');
    this.header = new HttpHeaders({
      Authorization: 'Bearer ' + this.token,
      Accept: '*/*',
    });
    return this.http.post(this._logout, {}, { headers: this.header });
  }
}
